import { ErrorMessage } from '@hookform/error-message';
import { yupResolver } from '@hookform/resolvers/yup';
import { useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from "react-tooltip";
import viewOff from '../../assets/images/view-off-icon.svg';
import viewOn from '../../assets/images/view-on-icon.svg';
import CheckboxWithLabel from '../../components/layouts/CheckboxWithLabel';
import Button from '../../components/ui/Button';
import CustomInput from '../../components/ui/CustomInput';
import CustomRadioWithTooltip from '../../components/ui/CustomRadioWithTooltip';
import Skeleton from '../../components/ui/Skeleton';
import { ApiConstants } from '../../constants/ApiConstants';
import { ApiTypes, StorageConstants } from '../../constants/Constants';
import { Routes } from '../../constants/RouteConstants';
import authContext from '../../context/authContext';
import useMakeRequest from '../../utils/ApiHelper';
import { saveToStorage } from '../../utils/Helper';
import { HouseHoldInvitationValidation, HouseHoldInvitationValidationPasswordOnly } from '../../validations/auth/HouseHoldInvitationValidation';

interface FormInputs {
    // email: string;
    invitee_Password?: string;
    password: string;
    confrim_password: string;
    agree_tnc?: boolean;
};

const HouseholdInvitation = () => {

    const navigate = useNavigate();
    const profile: any = useContext(authContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const linkData = profile?.link_data || profile?.data?.link_data;
    const user = queryParams.get("user") || (linkData?.access_type === "temp" ? "1" : "2");
    const hhName = queryParams.get("hhName") || linkData?.hhName;
    const hh_id = queryParams.get("hh_id") || linkData?.hh_id;
    const user_id = queryParams.get("user_id") || linkData?.user_id;

    const { state } = location;
    console.log("state --- >", state)
    console.log("userData --- >", state?.userData)
    console.log("user --- >", user)
    console.log("hhName --- >", hhName)
    console.log("hh_id --- >", hh_id)
    console.log("user_id --- >", user_id)
    // const login: any = useMakeRequest();
    const [showInvitePwd, setShowInvitePwd] = useState(false)
    const [showPwd, setShowPwd] = useState(false)
    const [showConfPwd, setShowConfPwd] = useState(false)
    const [loading, setLoading] = useState(false)
    const [selected, setSelected] = useState<number>(1);
    const [hasScrolledPrivacy, setHasScrolledPrivacy] = useState(false);
    const [hasScrolledTerms, setHasScrolledTerms] = useState(false);
    const [activeCmsPage, setActiveCmsPage] = useState<string | null>(null);

    const acceptRejectInvitation = useMakeRequest();
    const checkInvitation = useMakeRequest();



    const cmsPage = useMakeRequest();

    useEffect(() => {
        if (state?.access_token) {
            saveToStorage({ key: StorageConstants?.ACCESS_TOKEN, value: state?.access_token });
            saveToStorage({ key: StorageConstants?.USER_DETAIL, value: state?.userData });
        }
    }, [state])


    useEffect(() => {
        if (user_id) {
            checkInvitation.makeRequest({
                url: ApiConstants?.HouseholdCheckInvitation,
                payload: {
                    user_id: user_id
                }
            })
        }

    }, [user_id])

    console.log("checkInvitation: ", checkInvitation?.data)

    const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
        mode: 'onChange',
        resolver: selected == 1
            ? user == '2'
                ? yupResolver(HouseHoldInvitationValidationPasswordOnly)
                : yupResolver(HouseHoldInvitationValidation)
            : undefined,
        defaultValues: {
            agree_tnc: false
        }
    });

    const agreeTncValidation = {
        validate: () => {
            if (!hasScrolledPrivacy || !hasScrolledTerms) {
                return "Please read and accept the Privacy Policy & End User License Agreement.";
            }
            return true;
        }
    };

    const onSubmit = async (form: FormInputs) => {
        setLoading(true)

        const obj = {
            oldPassword: form.invitee_Password,
            password: form.password,
            user_id: user_id
        }
        const obj1 = {
            user_id: user_id
        }
        const obj2 = {
            password: form.password,
            user_id: user_id
        }

        const mainObj = selected == 1 ? user == "2" ? obj2 : obj : obj1

        const finalPayload = {
            invitation_id: checkInvitation?.data?.data?.uuid,
            hh_id: hh_id,
            status: selected,
            ...mainObj
        }

        console.log("finalPayload ==>", finalPayload)


        toast.promise(
            acceptRejectInvitation.makeRequest({
                payload: finalPayload,
                url: ApiConstants?.HouseholdAcceptRejectInvitation,
                type: "POST"
            }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        ).then(() => {
            setLoading(false)
        }).catch(() => {
            setLoading(false)
        })
    }

    const isProfileCalled = useRef(false);

    useEffect(() => {
        console.log("acceptRejectInvitation: ", acceptRejectInvitation)

        if (acceptRejectInvitation?.status) {

            if (selected == 1) {

                if (state?.userData?.is_profile_setup == 0) {
                    profile.update("invitation_accept_pending", false);
                    profile.update("has_pending_invitation", false);
                    if (profile?.data) {
                        profile.update("data", {
                            ...profile.data,
                            invitation_accept_pending: false,
                            has_pending_invitation: false
                        });
                    }
                    profile.makeRequest({
                        url: ApiConstants?.Profile,
                        type: ApiTypes?.GET
                    });
                    navigate(Routes?.ManageProfile);
                } else {

                    if (
                        acceptRejectInvitation?.data?.status_code == 422 &&
                        acceptRejectInvitation?.data?.data?.isMyAccount &&
                        !isProfileCalled.current
                    ) {
                        isProfileCalled.current = true;

                        profile.makeRequest({
                            url: ApiConstants?.Profile,
                            type: ApiTypes?.GET
                        });


                        navigate(Routes.Profile);
                        return;
                    }

                    profile.update("invitation_accept_pending", false);
                    profile.update("has_pending_invitation", false);
                    if (profile?.data) {
                        profile.update("data", {
                            ...profile.data,
                            invitation_accept_pending: false,
                            has_pending_invitation: false
                        });
                    }
                    profile.makeRequest({
                        url: ApiConstants?.Profile,
                        type: ApiTypes?.GET
                    });
                    navigate(Routes?.Dashboard);
                }

            } else {

                if (user == "2") {
                    profile.update("invitation_accept_pending", false);
                    profile.update("has_pending_invitation", false);
                    if (profile?.data) {
                        profile.update("data", {
                            ...profile.data,
                            invitation_accept_pending: false,
                            has_pending_invitation: false
                        });
                    }
                    profile.makeRequest({
                        url: ApiConstants?.Profile,
                        type: ApiTypes?.GET
                    });
                    navigate(Routes?.Dashboard);
                } else {
                    navigate(Routes?.Login);
                }

            }
        }

        if (acceptRejectInvitation?.error?.success) {
            if (user == "2") {
                profile.update("invitation_accept_pending", false);
                profile.update("has_pending_invitation", false);
                if (profile?.data) {
                    profile.update("data", {
                        ...profile.data,
                        invitation_accept_pending: false,
                        has_pending_invitation: false
                    });
                }
                profile.makeRequest({
                    url: ApiConstants?.Profile,
                    type: ApiTypes?.GET
                });
                navigate(Routes?.Dashboard);
            } else {
                navigate(Routes?.Login);
            }
        }

    }, [acceptRejectInvitation]);




    const viewCmsPage = (slug: string) => {
        setActiveCmsPage(slug);
        if (slug === 'privacy-policy') setHasScrolledPrivacy(false);
        if (slug === 'terms-and-conditions') setHasScrolledTerms(false);
        cmsPage.makeRequest({ payload: { detail_id: slug }, url: ApiConstants?.CmsPagesDetail })
    }

    const password = watch('password');

    const handleScroll = (e: any, type: any) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 5) {
            if (type === 'privacy') setHasScrolledPrivacy(true);
            if (type === 'terms') setHasScrolledTerms(true);
        }
    };

    return (
        <main id="main-content" className="auth-page login-page">
            <div className="auth-container">
                <h1 className='auth-title'>Accept Your Invitation!</h1>

                <label className="question-label mb-3 mt-3">
                    Would you like to join the household {hhName}?
                    <abbr
                        data-tooltip-id={"join-household"}
                        className="text-decoration-none cursor-pointer"
                    >
                        {" "}
                        <i className="icon-info ms-2"></i>
                    </abbr>

                </label>
                <ReactTooltip
                    style={{
                        zIndex: "1",
                        wordBreak: "break-word",
                        maxWidth: "90%",
                    }}
                    id={"join-household"}
                    place="bottom"
                    content={"Join Household"}
                />
                <div className="question-label d-flex gap-4 mb-3">
                    {[
                        {
                            title: "Yes",
                            type: 1,
                        },
                        {
                            title: "No",
                            type: 2,
                        },
                    ].map((join) => (
                        <CustomRadioWithTooltip
                            id={`${join?.type}`}
                            name="divisionRadio"
                            value={`${join?.type}`}
                            label={join?.title}
                            checked={join?.type === selected}
                            onChange={() => {
                                setSelected(join?.type);
                            }}
                        />
                    ))}
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className={`auth-form-wrap ${loading ? 'disabled-ct' : ''}`}>
                    <div className="auth-form-fields">
                        {user == '2' ? <div className="mb-3 com-input-grp">
                            <label className={`form-label ${selected === 2 ? 'label-disabled' : ''}`}>Current Password<sup className='label-star'>*</sup></label>
                            <div className='position-relative paas-eye-field'>
                                <input
                                    type={showPwd ? 'text' : 'password'}
                                    className={`form-control ${selected === 2 ? 'input-disabled' : ''}`}
                                    placeholder='Enter Current Password'
                                    {...register('password')}
                                    disabled={selected === 2}
                                />
                                <i className={`pass-eye ${showPwd ? "icon-eye" : "icon-eye-close"}`} onClick={() => setShowPwd(!showPwd)}></i>
                            </div>
                            <ErrorMessage
                                errors={errors}
                                name="password"
                                render={({ message }) => <p className='valid-error'>{message}</p>}
                            />
                        </div> :

                            <CustomInput
                                label="Invitee Password"
                                type={showInvitePwd ? 'text' : 'password'}
                                placeholder="Enter Password"
                                disabled={selected === 2}
                                required
                                {...register('invitee_Password')}
                                error={errors.invitee_Password?.message}
                                icon={
                                    showInvitePwd ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                                }
                                onIconClick={() => setShowInvitePwd(!showInvitePwd)}
                            />
                        }
                        {user == '1' &&
                            <>

                                <CustomInput
                                    label="New Password"
                                    type={showPwd ? 'text' : 'password'}
                                    placeholder="Enter New Password"
                                    disabled={selected === 2}
                                    required
                                    {...register('password')}
                                    error={errors.password?.message}
                                    icon={
                                        showPwd ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                                    }
                                    onIconClick={() => setShowPwd(!showPwd)}
                                />
                                {/* <div className="mb-3 com-input-grp">
                                <label className={`form-label ${selected === 2 ? 'label-disabled' : ''}`}>New Password<sup className='label-star'>*</sup></label>
                                <div className='position-relative paas-eye-field'>
                                    <input
                                        type={showPwd ? 'text' : 'password'}
                                        className={`form-control ${selected === 2 ? 'input-disabled' : ''}`}
                                        placeholder='Enter New Password'
                                        {...register('password')}
                                        disabled={selected === 2}
                                    />
                                    <i className={`pass-eye ${showPwd ? "icon-eye" : "icon-eye-close"}`} onClick={() => setShowPwd(!showPwd)}></i>
                                </div>
                                <ErrorMessage
                                    errors={errors}
                                    name="password"
                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                />
                            </div> */}

                                <CustomInput
                                    label="Confirm New Password"
                                    type={showConfPwd ? 'text' : 'password'}
                                    placeholder="Re-enter New Password"
                                    disabled={selected === 2}
                                    required
                                    {...register('confrim_password')}
                                    error={errors.confrim_password?.message}
                                    icon={
                                        showConfPwd ? <img className="calIcon" src={viewOn} alt="" /> : <img className="calIcon" src={viewOff} alt="" />
                                    }
                                    onIconClick={() => setShowConfPwd(!showConfPwd)}
                                />
                                {/* <div className="mb-3 com-input-grp">
                                <label className={`form-label ${selected === 2 ? 'label-disabled' : ''}`}>Confirm New Password<sup className='label-star'>*</sup></label>
                                <div className='position-relative paas-eye-field'>
                                    <input
                                        type={showConfPwd ? 'text' : 'password'}
                                        className={`form-control ${selected === 2 ? 'input-disabled' : ''}`}
                                        placeholder='Re-enter New Password'
                                        {...register('confrim_password')}
                                        disabled={selected === 2}
                                    />
                                    <i className={`pass-eye ${showConfPwd ? "icon-eye" : "icon-eye-close"}`} onClick={() => setShowConfPwd(!showConfPwd)}></i>
                                </div>
                                <ErrorMessage
                                    errors={errors}
                                    name="confrim_password"
                                    render={({ message }) => <p className='valid-error'>{message}</p>}
                                />
                            </div> */}
                            </>
                        }
                        {user !== '2' && selected == 1 && (
                            <>
                                <CheckboxWithLabel
                                    register={() =>
                                        register("agree_tnc", {
                                            ...agreeTncValidation,
                                            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                                                console.log("hasScrolledPrivacy: ", hasScrolledPrivacy)
                                                console.log("hasScrolledTerms: ", hasScrolledTerms)
                                                if (!hasScrolledPrivacy || !hasScrolledTerms) {
                                                    e.preventDefault();
                                                    setValue("agree_tnc", false, { shouldValidate: true });
                                                } else {
                                                    setValue("agree_tnc", e.target.checked, { shouldValidate: true });
                                                }
                                            },
                                        })
                                    }
                                    labelText="I accept the"
                                    links={[
                                        {
                                            text: 'Privacy Policy',
                                            onClick: () => viewCmsPage('privacy-policy'),
                                            isLink: true
                                        },
                                        {
                                            text: '&',
                                            isLink: false
                                        },
                                        {
                                            text: 'End User License Agreement',
                                            onClick: () => viewCmsPage('terms-and-conditions'),
                                            isLink: true
                                        },
                                        {
                                            text: '.',
                                            isLink: false
                                        },
                                    ]}
                                    errorMessage={
                                        <ErrorMessage
                                            errors={errors}
                                            name="agree_tnc"
                                            render={({ message }) => <p className="valid-error">{message}</p>}
                                        />
                                    }
                                />
                            </>
                        )}

                    </div>

                    <Button disabled={selected == 2 ? false : user !== '2' ? !hasScrolledPrivacy || !hasScrolledTerms : false} className='com-btn my-5' type='submit' loading={loading} >Submit</Button>

                </form>

                <div className="modal fade inner-modal c" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h1 className="modal-title fs-5" id="exampleModalLabel">{cmsPage?.data?.data?.title}</h1>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body"
                                style={{ maxHeight: '400px', overflowY: 'auto' }}
                                onScroll={(e) => handleScroll(e, activeCmsPage === 'privacy-policy' ? 'privacy' : 'terms')}
                            >
                                {
                                    cmsPage?.loading ?
                                        <>
                                            <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />

                                            <Skeleton className='skeleton-loader mt-5' style={{ width: '50%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '60%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '100%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '80%', height: '20px' }} />
                                            <Skeleton className='skeleton-loader my-2' style={{ width: '90%', height: '20px' }} />
                                        </>
                                        :
                                        <p dangerouslySetInnerHTML={{ __html: cmsPage?.data?.data?.content }}></p>
                                }            </div>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )
}

export default HouseholdInvitation